import { useState, useEffect, useCallback, forwardRef } from 'react'
import moment from 'moment-wrapper'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import Icon from 'components/Shared/Icon/Index'
import InputField from 'components/Shared/InputField/Index'

import colors from 'components/utils/colors'

const styleIconAsOpen = css`
  &:before {
    color: ${colors.primary40} !important;
  }
`

const StyledPickerIcon = styled(Icon)`
  &:before {
    font-size: 16px !important;
    width: 16px !important;
    height: 16px !important;
  }

  ${props => props.isOpen && styleIconAsOpen}
`

const DatetimeInputField = forwardRef((props, ref) => {
  const {
    value, onChange, onFocus, onBlur, onKeyDown, onClick,
    placeholder, isOpen, isReadOnly, width, format, userTimeZone,
  } = props

  const [val, setVal] = useState(value)
  const [lastCorrectValue, setLastCorrectValue] = useState(value)

  useEffect(() => {
    setVal(value)
    setLastCorrectValue(value)
  }, [value])

  const onChangeRaw_ = useCallback((e) => {
    const newValue = e.target.value
    setVal(newValue)
    const newMomentValue = moment.tz(newValue, format, true, userTimeZone)

    if (newMomentValue.isValid() || newValue === '') {
      setLastCorrectValue(newValue)
      onChange(e)
    }
  }, [format, userTimeZone, onChange])

  const onBlur_ = useCallback((e) => {
    const newMomentValue = moment.tz(e.target.value, format, true, userTimeZone)
    if (!newMomentValue.isValid()) {
      setVal(lastCorrectValue)
    }
    onBlur(e)
  }, [format, userTimeZone, lastCorrectValue, onBlur])

  let iconComponent
  if (!isReadOnly) {
    iconComponent = (
      <StyledPickerIcon
        iconName='icon-calendar'
        isOpen={isOpen}
      />
    )
  }

  return (
    <InputField
      value={val}
      onFocus={onFocus}
      onBlur={onBlur_}
      onChange={() => {}}
      onChangeRaw={onChangeRaw_}
      onKeyDown={onKeyDown}
      onClick={onClick}
      placeholder={placeholder}
      disabled={isReadOnly}
      iconComponent={iconComponent}
      width={width}
      innerRef={ref}
    />
  )
})

DatetimeInputField.displayName = 'DatetimeInputField'

DatetimeInputField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  onClick: PropTypes.func,
  placeholder: PropTypes.string,
  isOpen: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  width: PropTypes.string,
  format: PropTypes.string,
  userTimeZone: PropTypes.string,
}

export default DatetimeInputField
